'use client';
import Link from 'next/link';
import Image from 'next/image';

const FeaturedArticles = ({ featuredArticles, sidebarBlocksExist }) => {
  if (!featuredArticles || featuredArticles.length === 0) return null;

  return (
    <div
      data-name="featured-article-list"
      className={`mb-15 pt-6 ${sidebarBlocksExist ? '' : 'sm:pt-0'}`}
    >
      <p className="h5 pb-8">Featured Articles</p>
      {featuredArticles.length > 0 && (
        <ul>
          {featuredArticles.map((article, i) => {
            return (
              <li key={i}>
                <article
                  id={`featured-article-${article.uid}`}
                  className="group flex pb-6"
                  data-name="featured-article"
                >
                  <Link
                    href={article.url}
                    title={article.title}
                    prefetch={false}
                  >
                    <div className="h-[100px] w-[148px]">
                      <Image
                        src={article.feature_image.url}
                        alt={article.feature_image.title.replace(
                          /\.[^/.]+$/,
                          ''
                        )}
                        width="148"
                        height="100"
                        sizes="148px"
                        style={{ height: 100, width: 148 }}
                        className="object-cover transition ease-in-out group-hover:opacity-60"
                      />
                    </div>
                  </Link>
                  <Link
                    href={article.url}
                    title={article.title}
                    prefetch={false}
                    className="h6 group-hover:text-cozy-cognac pl-4"
                  >
                    {article.title}
                  </Link>
                </article>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default FeaturedArticles;
